import Vconsole from 'vconsole';
import Vue from 'vue';
import App from './App.vue';
import VueJsonp from 'vue-jsonp';
import { APP_CONFIG } from './config';
import router from './router';
import store from './store';
import animate from 'animate.css'
import './directive/index';

import MuseUI from 'muse-ui';
import 'muse-ui/dist/muse-ui.css';

Vue.config.productionTip = false;
Vue.use(VueJsonp);

Vue.config.ignoredElements = ['wx-open-launch-weapp'];
Vue.use(animate)
Vue.use(MuseUI);

// !!非生产环境的微信环境启用 vconsole
// if (!/event.fnws.top/gi.test(APP_CONFIG.baseUrl)) {
//   new Vconsole();
// }
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
